import { render, staticRenderFns } from "./QuizAnswerSelector.vue?vue&type=template&id=428e0711&scoped=true"
import script from "./QuizAnswerSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./QuizAnswerSelector.vue?vue&type=script&setup=true&lang=js"
import style0 from "./QuizAnswerSelector.vue?vue&type=style&index=0&id=428e0711&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428e0711",
  null
  
)

export default component.exports